<template>
  <div class="navigation" v-bind:class="[prevRoute === undefined ? '--noprev' : '']">
    <div
      v-if="prevRoute"
      class="navigation__button navigation__button--prev"
      @click="$_scrollTopAndNavigate(prevRoute)"
      @mouseover="updateMouseCursor('button')"
      @mouseout="updateMouseCursor('default')">
      {{ prevRouteName }}
    </div>

    <div
      v-if="nextRoute"
      class="navigation__button navigation__button--next"
      @click="$_scrollTopAndNavigate(nextRoute)"
      @mouseover="updateMouseCursor('button')"
      @mouseout="updateMouseCursor('default')">
      {{ nextRouteName }}
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapMutations } from 'vuex'
import routesList from '@/router/routesList'

export default {
  computed: {
    nextRoute: {
      get () {
        return _.head(_.keys(_.pickBy(routesList, route => route.position === this.$route.meta.position + 1)))
      }
    },
    prevRoute: {
      get () {
        return _.head(_.keys(_.pickBy(routesList, route => route.position === this.$route.meta.position - 1)))
      }
    },
    nextRouteName: {
      get () {
        return routesList[this.nextRoute].footerName
      }
    },
    prevRouteName: {
      get () {
        return routesList[this.prevRoute].footerName
      }
    }
  },
  methods: {
    ...mapMutations('animations', [
      'updateMouseCursor'
    ]),
    $_scrollTopAndNavigate (route) {
      this.$router.push({ name: route })
    }
  }
}
</script>

<style lang="scss">
@import '../../assets/scss/breakpoint.scss';

$white: #f2f2f2;

.navigation {
  display: flex;
  padding: 5rem 6.25%;
  background: #001a53;
  &.--noprev{
    justify-content: flex-end;
  }
  @include media('>=xlarge'){
    padding: 15rem 3.25%;
  }
}

.navigation__button {
  width: 50%;
  cursor: pointer;
  color: $white;
  font-size: 2.4rem;
  @include media('>=large'){
    font-size: 3.1rem;
  }
  @include media('>=xlarge'){
    font-size: 4.8rem;
  }
}

.navigation__button--next {
  text-align: right;
}

.navigation__button--prev::after, .navigation__button--next::before{
  content: "";
  display: inline-block;
  background: $white;
  width: 2.5rem;
  height: 1px;
  transform: scaleX(1);
  transition: transform .3s;
  @include media('>=large'){
    width: 5rem;
  }
  @include media('>=xlarge'){
    width: 7.5rem;
  }
}
.navigation__button--prev::after{
  transform-origin: left;
}
.navigation__button--next::before{
  transform-origin: right;
}
.navigation__button:hover{
  &::before{
    transform: scaleX(.75);
    transform-origin: right;
  }
  &::after{
    transform: scaleX(.75);
    transform-origin: left;
  }
}

</style>
